"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PinCode;

require("core-js/modules/web.dom-collections.iterator.js");

var _PinCodeModule = _interopRequireDefault(require("../../assets/styles/components/PinCode.module.scss"));

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let setAutoFocus = false;

function PinCode(_ref) {
  let {
    disabled,
    error,
    positive,
    size = "default",
    placeholder = "○",
    values = [],
    onChange,
    type = "text"
  } = _ref;
  const inputsRef = (0, _react.useRef)([]);
  (0, _react.useEffect)(() => {
    setAutoFocus = false;
  }, []);
  (0, _react.useEffect)(() => {
    if (inputsRef.current[0] && !setAutoFocus) {
      setAutoFocus = true;
      inputsRef.current[0].focus();
    }
  }, [inputsRef]);

  const changeInput = (value, index) => {
    let tmp_values = values;
    tmp_values[index] = value;
    onChange(tmp_values);

    if (inputsRef.current[index + 1]) {
      inputsRef.current[index + 1].focus();
      setfocusIndex(focusIndex + 1);
    }
  };

  const [focusIndex, setfocusIndex] = (0, _react.useState)(0);

  const pressBackspace = (e, index) => {
    if (e.key === "Backspace" && e.target.value.length === 0) {
      if (inputsRef.current[index - 1]) {
        const v = inputsRef.current[index - 1].value;
        inputsRef.current[index - 1].value = "";
        inputsRef.current[index - 1].focus();
        inputsRef.current[index - 1].value = v;
        setfocusIndex(focusIndex - 1);
      }
    }

    if (e.key === "ArrowLeft") {
      if (inputsRef.current[index - 1]) {
        const v = inputsRef.current[index - 1].value;
        inputsRef.current[index - 1].value = "";
        inputsRef.current[index - 1].focus();
        inputsRef.current[index - 1].value = v;
        setfocusIndex(focusIndex - 1);
      }
    }

    if (e.key === "ArrowRight") {
      if (inputsRef.current[index + 1]) {
        const v = inputsRef.current[index + 1].value;
        inputsRef.current[index + 1].value = "";
        inputsRef.current[index + 1].focus();
        inputsRef.current[index + 1].value = v;
        setfocusIndex(focusIndex + 1);
      }
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "\n            ".concat(_PinCodeModule.default.pincode, "\n            ").concat(size === "mini" ? _PinCodeModule.default.size_mini : size === "compact" ? _PinCodeModule.default.size_compact : size === "default" ? _PinCodeModule.default.size_default : size === "large" ? _PinCodeModule.default.size_large : _PinCodeModule.default.size_default, "\n            \n        "),
    children: Array.isArray(values) && values.map((v, i) => {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
        className: "\n                    ".concat(error && _PinCodeModule.default.error_true, "\n                    ").concat(positive && _PinCodeModule.default.positive_true, "\n                "),
        disabled: disabled,
        type: type,
        autoFocus: i === focusIndex,
        onKeyDown: e => {
          pressBackspace(e, i);
        },
        onChange: e => {
          changeInput(e.currentTarget.value, i);
        },
        ref: el => inputsRef.current[i] = el,
        placeholder: placeholder,
        defaultValue: v,
        maxLength: 1
      }, i);
    })
  });
}